<template>
  <div class="container mt-5 mb-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card shadow-lg p-4">
          <h2 class="text-center text-primary mb-4">
            <i class="fa fa-sign-in me-2 text-primary"></i>{{ $t("login.title") }}
          </h2>

          <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

          <form @submit.prevent="login">
            <div class="mb-3">
              <label for="email" class="form-label">{{ $t("login.email") }}</label>
              <input
                type="email"
                id="email"
                class="form-control"
                v-model="email"
                required
                :placeholder="$t('login.emailPlaceholder')"
              />
            </div>

            <div class="mb-3">
              <label for="password" class="form-label">{{ $t("login.password") }}</label>
              <input
                type="password"
                id="password"
                class="form-control"
                v-model="password"
                required
                :placeholder="$t('login.passwordPlaceholder')"
              />
            </div>

            <button type="submit" class="btn btn-primary w-100">
              <i class="fa fa-unlock-alt me-2"></i>{{ $t("login.button") }}
            </button>
          </form>

          <div class="text-center mt-3">
            <router-link to="/forgot-password" class="forgot-password-link">
              <i class="fa fa-key me-1"></i>{{ $t("login.forgotPassword") }}
            </router-link>
          </div>

          <div class="text-center mt-3">
            <p>
              {{ $t("login.noAccount") }}
              <router-link to="/inregistrare" class="register-link">
                <i class="fa fa-user-plus me-1"></i>{{ $t("login.registerLink") }}
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  border-radius: 10px;
  background: #ffffff;
  border: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
h2 {
  font-size: 1.8rem;
  font-weight: bold;
}
.form-control {
  border-radius: 8px;
  border: 1px solid #ccc;
  padding: 12px;
}
.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}
.btn-primary {
  background-color: #007bff;
  border: none;
  padding: 12px;
  font-size: 1.1rem;
  border-radius: 8px;
}
.btn-primary:hover {
  background-color: #0056b3;
}

.forgot-password-link {
  color: #dc3545;
  font-weight: bold;
  text-decoration: none;
  transition: color 0.3s;
}
.forgot-password-link:hover {
  color: #b22222;
}

.register-link {
  color: #007bff;
  font-weight: bold;
  text-decoration: none;
}
.register-link:hover {
  color: #0056b3;
}
.alert-danger {
  font-size: 0.9rem;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
}
</style>

<script>
import axios from "axios";

export default {
  name: "ClientLogin",
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
      successMessage: "",
    };
  },
  methods: {
    async login() {
      if (!this.email.includes("@") || this.password.length < 6) {
        this.errorMessage = this.$t("login.error");
        return;
      }

      this.errorMessage = "";
      this.successMessage = "";

      const requestData = {
        email: this.email.trim(),
        password: this.password.trim(),
      };

      console.log("📡 Trimitem request:", requestData);

      try {
        const response = await axios.post("https://api.feribot-eurobac.ro/client/api/login/", requestData, {
          headers: { "Content-Type": "application/json" },
          withCredentials: true, // Permite cookie-uri pentru sesiune
        });

        this.successMessage = this.$t("login.success");
        console.log("✅ Autentificare reușită:", response.data);

        setTimeout(() => {
          window.location.href = "/dashboard"; // Refresh complet al paginii
        }, 500);
      } catch (error) {
        if (error.response) {
          this.errorMessage = error.response.data.error || this.$t("login.errorServer");
        } else {
          this.errorMessage = this.$t("login.errorNetwork");
        }
      }
    }
  }
};
</script>
